import React from "react";
import { useEffect, useState } from "react";

// MUI imports
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Fade from "@mui/material/Fade";
import Backdrop from "@mui/material/Backdrop";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import DocumentCard from "./DocumentCard"; // Assuming you have a DocumentCard component
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import Tooltip from "@mui/material/Tooltip";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import SettingsBackupRestoreIcon from "@mui/icons-material/SettingsBackupRestore";
import SendIcon from "@mui/icons-material/Send";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
// antd imports.
import { InputNumber, ColorPicker } from "antd";


const lightTheme = createTheme({
  palette: {
    mode: 'light', // Define the theme as light
    // You can customize other theme properties here
  },
});

export const darkThemeModal = {
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    backgroundColor: "#ooo",
    padding: "24px", // Increased padding
    borderRadius: "8px",
    color: "#ccc",
    minWidth: "400px", // Increased width
    maxWidth: "500px", // Increased width
    maxHeight: "80%", // Set maximum height
    overflowY: "auto", // Enable vertical scrolling if needed
  },
  documentCard: {
    backgroundColor: "#444",
    padding: "16px",
    borderRadius: "8px",
    marginBottom: "16px",
  },
};

const IndicatorSettingsModal = ({ open, handleClose, settings, header, ...props }) => {
  // console.log("settings", settings)
  return (
    <Modal
      aria-labelledby="spring-modal-title"
      aria-describedby="spring-modal-description"
      open={open}
        onClose={handleClose}
      closeAfterTransition
      BackdropProps={{
        timeout: 500,
      }}
      sx={{ ...darkThemeModal.modal, zIndex: 10 }}
      //   id= {modalId}
    >
      <Fade in={open}>
        <Box sx={darkThemeModal.modalContent}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="border modal-content-1 create-folder-modal-content login_modal_wrapper ">
              <div className="modal-header">
                <h5 className="modal-title">
                  {header ? header : "SMA"}{" "}
                </h5>
                <button
                  type="button"
                  className="btn-close  btn-close-white left-col-space text-white"
                  onClick = {handleClose}
                ></button>
              </div>
              <div className="modal-body text-center">
                <Box
                  sx={{
                    display: "flex",
                    margin: " auto",
                    alignItems: "center",
                    marginTop: "1rem",
                  }}
                >
                  <Box sx={{ margin: " auto" }}>
                    <div className="inner-tBgV1m0B">Length</div>
                  </Box>
                  <Box sx={{ margin: " auto" }}>
                    <InputNumber min={1} max={200} value={settings["period"]} onChange={props.handleChangeInputLength} />
                  </Box>
                </Box>
                {/* <Box
                  sx={{
                    display: "flex",
                    margin: " auto",
                    alignItems: "center",
                    marginTop: "1rem",
                  }}
                >
                  <Box sx={{ margin: " auto" }}>
                    <div className="inner-tBgV1m0B">Source</div>
                  </Box>
                  <Box sx={{ margin: " auto" }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={"close"}
                    label="Source"
                    theme={lightTheme}
                  >
                    <MenuItem value={"close"}>close</MenuItem>
                    <MenuItem value={"open"}>open</MenuItem>
                    <MenuItem value={"high"}>high</MenuItem>
                    <MenuItem value={"low"}>low</MenuItem>
                  </Select>
                  </Box>
                </Box> */}
                <Box
                  sx={{
                    display: "flex",
                    margin: " auto",
                    alignItems: "center",
                    marginTop: "1rem",
                  }}
                >
                  <Box sx={{ margin: " auto" }}>
                    <div className="inner-tBgV1m0B">Style</div>
                  </Box>
                  <Box sx={{ margin: " auto" }}>
                    <ColorPicker format="hex" value={settings?.style?.color}  onChange={props?.handleChangeIndicatorConfigurationsColor}/>
                  </Box>
                </Box>
              </div>
              <div className="modal-footer">
                <Box
                  sx={{
                    display: "flex",
                    margin: " auto",
                    alignItems: "center",
                    marginTop: "1rem",
                  }}
                >
                  <Box sx={{ margin: " auto" }}>
                    <Tooltip
                      title="reset settings to default"
                      placement="top-end"
                    >
                      <Button
                        variant="outlined"
                        startIcon={<SettingsBackupRestoreIcon />}
                      >
                        Defaults
                      </Button>
                    </Tooltip>
                  </Box>
                  <Box sx={{ margin: " auto" }}>
                    <Button variant="outlined" startIcon={<SendIcon />} onClick={props?.handelClickSaveIndicatorSetting}>
                      Apply
                    </Button>
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        </Box>
      </Fade>
    </Modal>
  );
};

export default IndicatorSettingsModal;
